import folder from '../../../../assets/images/files/folder.png';
import files from '../../../../assets/images/files/file.png';
import wordfile from '../../../../assets/images/files/word.png';
import doc from '../../../../assets/images/files/doc.png';
import image from '../../../../assets/images/files/image.png'


export const Filemangerlistdata1 = [
    { id: 1, imageSrc: folder, title: "Videos", size: "4.23GB" },
    { id: 2, imageSrc: folder, title: "Images", size: "1.23GB" },
    { id: 3, imageSrc: folder, title: "Downloads", size: "453kb" },
    { id: 4, imageSrc: files, title: "Document.pdf", size: "23KB" },
    { id: 5, imageSrc: files, title: "Document.pdf", size: "23KB" },
    { id: 6, imageSrc: wordfile, title: "Word Document", size: "23KB" },
    { id: 7, imageSrc: files, title: "Document.pdf", size: "23KB" },
    { id: 8, imageSrc: files, title: "Document.pdf", size: "23KB" },
    { id: 9, imageSrc: folder, title: "Downloads", size: "453kb" },
    { id: 10, imageSrc: files, title: "Document.pdf", size: "23KB" },
    { id: 11, imageSrc: files, title: "Document.pdf", size: "23KB" },
    { id: 12, imageSrc: folder, title: "Downloads", size: "453kb" },
    { id: 13, imageSrc: doc, title: "Document", size: "23kb" },
    { id: 14, imageSrc: image, title: "login image", size: "23kb" },
    { id: 14, imageSrc: image, title: "beach image", size: "4.23gb" },
    { id: 15, imageSrc: image, title: "sky image", size: "1.23gb" },
    { id: 14, imageSrc: image, title: "Sea", size: "879mb" },
    { id: 14, imageSrc: image, title: "Outdoor Image", size: "23kb" },
]